// extracted by mini-css-extract-plugin
export default {"HomeCard":"Home_HomeCard__2sWhx","cardContainer":"Home_cardContainer__z245Q"};